<template>
  <footer class="footer noPrint">
    <div class="firstRow row">
      <div class="col-sm-12">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 text-center">
<!--              <a>Ministrstvo za pravosodje</a> &nbsp;&nbsp;|&nbsp;&nbsp; <a>Vrhovno-->
<!--              sodišče Republike Slovenije</a>-->
              <img src="@/assets/images/eu-logos.png" alt="ESS" class="img-fluid mt-2 mb-1" style="max-height: 60px" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="secondRow row">
      <div class="col-sm-12">
        <div class="container">
          <div class="row">
            <div class="col-sm-6 text-left mt-0"><a href="#">{{$t('text.footer.vsrs')}}<span>{{moment().format('YYYY')}}</span></a>
            </div>
              <div class="col-sm-6 text-right mt-0">
                  <span class="badge-info pt-1 pb-1 pl-2 pr-2">{{$t('text.footer.version')}}: <b>{{version}}</b></span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>


<script>
    import Vue from 'vue';
    import {version} from '../../package';

    export default {
        name: 'Footer',
        data() {
            return {
                version: null
            };
        },
        mounted() {
            this.version = this.$globalFunctions.getAppVersionData("environment") !== 'PROD' ? this.$globalFunctions.getAppVersionData() : this.$globalFunctions.getAppVersionData("number");
        },
        methods: {},
    };
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue